export const winterConstants = {
  LOAD: 'PROMO_WINTER_STATUS_LOAD',
  LOADING: 'PROMO_WINTER_STATUS_LOADING',
  LOADED: 'PROMO_WINTER_STATUS_LOADED',
};
